export enum NewLivestreamModalSteps {
    SelectDestination = "select-destination",
    PlatformSettings = "platform-settings",
    LivestreamDetails = "livestream-details",
    Processing = "processing"
}

export enum ValidationErrors {
    TitleRequired = "title-required",
    StartTimeMustBeInFuture = "start-time-must-be-in-future",
    FacebookDescriptionRequired = "facebook-description-required"
}

export enum SubmissionStatus {
    Success = "success",
    Failure = "failure",
    Mixed = "mixed"
}
